module.exports = __webpack_public_path__ + "img/andauernd-mit-starken-schwankung.ab1a1a4f.png";